module.exports = __webpack_public_path__ + "static/img_1490-a71997c2ab3ff6b07d0f5643094b1345.webp";